import { formatBRLFromReais } from '@doutorsim/shared/helpers/currency'
import { parseDateToIsoDateString } from '@doutorsim/shared/helpers/parse-date'
import dayjs from 'dayjs'
import type { RowConfig } from './field-config'

// Yggy and patient declarations carry the bare 2-letter UF (e.g. "BA", "RN"),
// while the backend validator + Select options use the ISO-3166-2 form ("BR-BA",
// "BR-RN"). Prefix bare codes; pass already-prefixed ones through unchanged.
export const toIsoSubdivisionCode = (value: string): string => {
  const v = value.trim().toUpperCase()
  if (!v) return ''
  if (/^[A-Z]{2}-[A-Z0-9]{1,10}$/.test(v)) return v
  if (/^[A-Z0-9]{1,10}$/.test(v)) return `BR-${v}`
  return v
}

// Normalize any accepted date format to the DD/MM/YYYY the form's row state and
// masked birth-date input work in; returns '' when the value doesn't fully
// parse. The accepted formats live in the shared parser so the prefill
// tolerance always matches the server's match classification.
export const toDisplayDate = (value: string): string => {
  const isoDate = parseDateToIsoDateString(value)
  return isoDate ? dayjs(isoDate).format('DD/MM/YYYY') : ''
}

export const parseBirthDate = (value: string): Date | null => {
  const isoDate = parseDateToIsoDateString(value)
  return isoDate ? dayjs(isoDate).toDate() : null
}

// A birth date must fully parse and cannot be in the future. Empty, incomplete,
// and malformed values are all invalid.
export const isBirthDateValid = (value: string): boolean => {
  const isoDate = parseDateToIsoDateString(value)
  return isoDate !== null && !dayjs(isoDate).isAfter(dayjs(), 'day')
}

export const formatRowValueForDisplay = (row: RowConfig, value: string): string => {
  if (row.key === 'income') {
    const parsed = Number(value)
    if (!Number.isNaN(parsed)) return formatBRLFromReais(parsed)
  }
  if (row.subField === 'postcode') {
    const digits = value.replace(/\D/g, '')
    if (digits.length === 8) return `${digits.slice(0, 5)}-${digits.slice(5)}`
  }
  if (row.key === 'birth_date') {
    const display = toDisplayDate(value)
    if (display) return display
  }
  return value
}
